// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"73e89900","845":"2be9191b"}[chunkId] + ".chunk.js";
};